import {
  getLocalStorageItem,
  setLocalStorageItem
} from "@/utils/localStorageUtility";

/**
 * User Local Storage Keys
 * @type {Readonly<{buttonTextStyle: string, usesAppTabs: string, dialogToolbarStyle: string, buttonColor: string, usesSidebarImage: string, usesJumpDialog: string, buttonsOutlined: string, toolbarDetailsColor: string, menuItemColor: string, userName: string}>}
 */
const localStorageKey = Object.freeze({
  userName: "userName",
  usesJumpDialog: "UsesModalJump",
  usesAppTabs: "UsesAppTabs",
  usesSidebarImage: "UsesSidebarImage",
  dialogToolbarStyle: "dialogToolbarStyle",
  buttonTextStyle: "buttonTextStyle",
  buttonsOutlined: "buttonOutlined",
  buttonColor: "buttonColor",
  menuItemColor: "menuItemColor",
  toolbarDetailsColor: "toolbarDetailsColor"
});

/**
 * Store User Name to the local Storage
 * @param {String} name:
 */
const storeUserName = name =>
  setLocalStorageItem(localStorageKey.userName, name);
/**
 * Get Stored User Name from local Storage
 * @returns {String|string}
 */
const getStoredUserName = () => getLocalStorageItem(localStorageKey.userName);

/**
 * User settings
 */

/**
 * Store UsesModalDialogJump to the local Storage
 * @param {String} usesModalJump
 */
const storeUsesModalJump = usesModalJump =>
  setLocalStorageItem(localStorageKey.usesJumpDialog, usesModalJump);
/**
 * Get Stored UsesModalDialogJump from local Storage
 * @returns {String}
 */
const getStoredUsesModalDialogJump = () =>
  getLocalStorageItem(localStorageKey.usesJumpDialog);

/**
 * Store UsesAppTabs to the local Storage
 * @param {String} usesAppTabs
 */
const storeUsesAppTabs = usesAppTabs =>
  setLocalStorageItem(localStorageKey.usesAppTabs, usesAppTabs);

/**
 * Get Stored UsesAppTabs from local Storage
 * @returns {String}
 */
const getStoredUsesAppTabs = () =>
  getLocalStorageItem(localStorageKey.usesAppTabs);

/**
 * store Uses Sidebar Image to local Storage
 * @param {String|string} usesSidebarImage
 */
const storeUsesSidebarImage = usesSidebarImage =>
  setLocalStorageItem(localStorageKey.usesSidebarImage, usesSidebarImage);
/**
 * Get Uses Sidebar Image from local Storage
 * @returns {string}
 */
const getStoredUsesSidebarImage = () =>
  getLocalStorageItem(localStorageKey.usesSidebarImage);

/**
 * Store Dialog Toolbar rStyle
 * @param {String|string} value
 */
const storeDialogToolbarStyle = value =>
  setLocalStorageItem(localStorageKey.dialogToolbarStyle, value);
/**
 * get Dialog Toolbar Style
 * @returns {string}
 */
const getDialogToolbarStyle = () =>
  getLocalStorageItem(localStorageKey.dialogToolbarStyle);

/**
 * Store Command Buttons Text Style
 * @param {String|string} value
 */
const storeCommandButtonTextStyle = value =>
  setLocalStorageItem(localStorageKey.buttonTextStyle, value);
/**
 * Get Command Buttons Text Style
 * @returns {string}
 */
const getCommandButtonTextStyle = () =>
  getLocalStorageItem(localStorageKey.buttonTextStyle);

/**
 * Store Command Buttons Outlined
 * @param {String|string} value
 */
const storeCommandButtonOutlined = value =>
  setLocalStorageItem(localStorageKey.buttonsOutlined, value);
/**
 * Get Command Buttons Outlined
 * @returns {string}
 */
const getCommandButtonOutlined = () =>
  getLocalStorageItem(localStorageKey.buttonsOutlined);
/**
 * Get Stored Data Table Configuration
 * @param {string} appName
 * @param {string} moduleName
 * @param {string} tableName
 * @returns {any|null}
 */
const getStoredDataTableConfiguration = (appName, moduleName, tableName) => {
  const name = buildDataTableNameKey(appName, moduleName, tableName);
  const config = getLocalStorageItem(name);

  return config ? JSON.parse(config) : null;
};

/**
 * Store Data Table Configuration
 * @param {string} appName
 * @param {string} moduleName
 * @param {string} tableName
 * @param {any} configuration
 */
const storeDataTableConfiguration = (
  appName,
  moduleName,
  tableName,
  configuration
) => {
  const name = buildDataTableNameKey(appName, moduleName, tableName);

  setLocalStorageItem(name, JSON.stringify(configuration));
};

/**
 * Build Data Table local Storage Key
 * @param {string} appName
 * @param {string} moduleName
 * @param {string} tableName
 * @returns {string}
 */
const buildDataTableNameKey = (appName, moduleName, tableName) =>
  `${appName.substring(0, 3)}_${moduleName}_${tableName}`;

/**
 * Store Button Color
 * @param {String} color
 */
const storeButtonColor = color =>
  setLocalStorageItem(localStorageKey.buttonColor, color);
/**
 * get Stored Button Color
 * @returns {string}
 */
const getStoredButtonColor = () =>
  getLocalStorageItem(localStorageKey.buttonColor);

/**
 * Store Menu Item Color
 * @param color
 */
const storeMenuItemColor = color =>
  setLocalStorageItem(localStorageKey.menuItemColor, color);
/**
 * get Stored Menu Item Color
 * @returns {string}
 */
const getStoredMenuItemColor = () =>
  getLocalStorageItem(localStorageKey.menuItemColor);

/**
 * Store Toolbar Details Color
 * @param color
 */
const storeToolbarDetailsColor = color =>
  setLocalStorageItem(localStorageKey.toolbarDetailsColor, color);
/**
 * get Toolbar Details Color
 * @returns {string}
 */
const getToolbarDetailsColor = () =>
  getLocalStorageItem(localStorageKey.toolbarDetailsColor);

export {
  storeUserName,
  getStoredUserName,
  storeUsesModalJump,
  getStoredUsesModalDialogJump,
  storeUsesAppTabs,
  getStoredUsesAppTabs,
  getStoredUsesSidebarImage,
  storeUsesSidebarImage,
  getStoredDataTableConfiguration,
  storeDataTableConfiguration,
  storeDialogToolbarStyle,
  getDialogToolbarStyle,
  storeCommandButtonTextStyle,
  getCommandButtonTextStyle,
  storeCommandButtonOutlined,
  getCommandButtonOutlined,
  storeButtonColor,
  getStoredButtonColor,
  storeMenuItemColor,
  getStoredMenuItemColor,
  storeToolbarDetailsColor,
  getToolbarDetailsColor
};
